/* eslint-disable no-nested-ternary */
import React from 'react';
import Star from 'crehana-icons/Star';
import StarO from 'crehana-icons/StarO';
import StarHalfO from 'crehana-icons/StarHalfO';
import Text from 'crehana-ui/Text';
import { yellowLight } from 'crehana-ui/styles/colors';

import { CourseCardProps } from 'Jsx/Shared/CourseCardV3/types';

const RatingStar = ({ index, average }: { index: number; average: number }) => {
  if (average === 0) {
    return <StarO key={index} size={12} color={yellowLight} />;
  }

  if (index < Math.floor(average)) {
    return <Star size={12} color={yellowLight} />;
  }

  const delta = average - index;

  if (delta <= 0.5) {
    return <StarHalfO key={index} size={12} color={yellowLight} />;
  }
  if (delta <= 0.99) {
    return <Star key={index} size={12} color={yellowLight} />;
  }

  return <StarO key={index} size={12} color={yellowLight} />;
};

const Rating: React.FC<Partial<CourseCardProps>> = props => {
  const { score } = props;

  if (!score) {
    return null;
  }

  return (
    <div className="flex items-center relative">
      {Array.from({ length: 5 }).map((_, i) => (
        <RatingStar key={i} index={i} average={score.average} />
      ))}
      <Text type="caption" color="base-main" className="ml-4">
        {score.average}
      </Text>
    </div>
  );
};

export default Rating;
